
export default function ListarNomes(props) {

  return (
    <div className="row">
      <ul className="col-lg-12 list-unstyled text-center" style={{columns: 2}}>
        {props.nomes.map((v, k) => {
            return (
              <li key={k} className="link-underline">
                {v.nome}
              </li>
            )
        })}
      </ul>
    </div>
  )

}